import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.sass'],
})
export class SearchFilterComponent {
  @Output() applyFilter: EventEmitter<Event> = new EventEmitter();

  @Output() searchInput: EventEmitter<string> = new EventEmitter();

  @Input() input: string = '';

  setFilter(event: Event) {
    this.applyFilter.emit(event);
  }

  hitEnter() {
    const element = document.getElementById('inText');
    const event = new KeyboardEvent('keyup', {
      key: 'enter',
    });
    element?.dispatchEvent(event);
  }

  setInput(value: string) {
    this.searchInput.emit(value);
  }
}
